import ApplicationController from '../application_controller';

/**
 * Se marca un checkbox como dependiente de otro checkbox. El checkbox que tiene el controller,
 * se va a desmarcar si el padre no está marcado
 */
export default class extends ApplicationController {
  connect() {
    this.parent = this.element.dataset.padre;
    this.parentCheckbox = document.querySelector(this.parent);
    this.parentCheckbox.addEventListener('change', () => {
      this.#actualizarEstado();
    });
    this.#actualizarEstado();
  }

  #actualizarEstado() {
    if (this.parentCheckbox.checked) {
      this.element.removeAttribute('disabled');
    } else {
      this.element.setAttribute('disabled', 'disabled');
      this.element.checked = false;
    }
  }
}
